export const Roles = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  CLIENT: 'client',
};
